import { render, staticRenderFns } from "./AdminInquiryList.vue?vue&type=template&id=b083c10c&scoped=true"
import script from "./AdminInquiryList.vue?vue&type=script&lang=js"
export * from "./AdminInquiryList.vue?vue&type=script&lang=js"
import style0 from "./AdminInquiryList.vue?vue&type=style&index=0&id=b083c10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b083c10c",
  null
  
)

export default component.exports